var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Editor/mac") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Editor/mac",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#555555",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vectorized_Apple_gray_logo",
    transform: "translate(5.000000, 3.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.98397729,0 C9.98397729,0 8.50244515,0.0312108346 7.14394682,1.21276386 C5.78544848,2.39431688 6.01457845,3.98606945 6.01457845,3.98606945 C6.01457845,3.98606945 7.35937902,4.19994392 8.79465045,2.95165322 C10.2299219,1.70336251 9.98397729,0 9.98397729,0 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.12224458,4.75238603 C6.2591982,4.74696243 5.72904164,4.06225769 4.2592083,4.06225769 C2.93666227,4.06225769 1.61086439,4.84627596 1.04712901,5.6048975 C0.486009246,6.35997909 0,7.18813309 0,8.86879857 C0,10.549464 0.880719445,13.4398839 3.04641199,15.3966007 C3.4172989,15.7316945 3.9082566,15.9835833 4.46835133,15.999172 C5.47571595,16.0271994 6.09427317,15.334343 7.36673374,15.334343 C8.63919431,15.334343 9.0220989,15.999172 10.170848,15.999172 C10.6932284,15.999172 11.2889521,15.7805719 11.8674621,15.2152837 C12.6097308,14.4899832 13.5308155,13.1085898 14,11.7835759 C14,11.7835759 11.6505076,10.9498684 11.6789259,8.54672785 C11.7025017,6.55483886 13.5434341,5.57511643 13.5434341,5.57511643 C13.5434341,5.57511643 12.4683109,4 10.1826183,4 C8.60384818,4.01084719 7.8968903,4.75725752 7.12224458,4.75238603 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.782f8e01149799dca4d64b04cefb3746.svg";
export { ForwardRef as ReactComponent };